// 全局主题样式配置

// 霓虹效果
export const NEON_BORDER = `
  0 0 2px #2563eb,
  0 0 4px #2563eb,
  0 0 6px #2563eb,
  0 0 10px #2563eb
`

export const NEON_SHADOW = `
  0 0 5px rgba(37, 99, 235, 0.3),
  0 0 10px rgba(37, 99, 235, 0.2),
  0 0 15px rgba(37, 99, 235, 0.1)
`

// 表单元素样式
export const INPUT_STYLES = "bg-black/50 backdrop-blur-md border border-green-700/30 focus-visible:ring-1 focus-visible:ring-green-500 focus-visible:ring-offset-0 text-white placeholder-gray-400 transition-all duration-300"

// 按钮样式
export const PRIMARY_BUTTON = "bg-gradient-to-r from-green-400 to-cyan-400 hover:from-green-500 hover:to-cyan-500 text-white font-bold hover:shadow-[0_0_15px_rgba(37,99,235,0.5)] transform hover:-translate-y-0.5 transition-all duration-300"

// 创建相似内容按钮样式
export const CREATE_SIMILAR_BUTTON = "w-full flex justify-center items-center py-2.5 rounded-lg bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-medium text-sm shadow-[0_0_10px_rgba(37,99,235,0.2)] hover:shadow-[0_0_15px_rgba(37,99,235,0.4)] transform hover:-translate-y-0.5 transition-all duration-300"

// 下载按钮样式
export const DOWNLOAD_BUTTON = "w-full flex justify-center items-center py-2.5 rounded-lg bg-gradient-to-r from-green-500 to-cyan-500 text-white font-medium text-sm hover:opacity-90 transition-opacity"

// 图标按钮基础样式
export const ICON_BUTTON = `
  flex items-center justify-center
  w-9 h-9
  text-gray-400 hover:text-green-400
  bg-black/60 hover:bg-black/80
  rounded-xl
  transition-colors duration-200
  backdrop-blur-sm
  border border-green-500/20 hover:border-green-500/40
  shadow-[0_0_10px_rgba(37,99,235,0.1)]
  hover:shadow-[0_0_15px_rgba(37,99,235,0.2)]
  tooltip-delay-0
`

// AI 优化按钮样式
export const AI_OPTIMIZE_BUTTON = `
  ${ICON_BUTTON}
  disabled:opacity-50 disabled:cursor-not-allowed
  group
`

// 卡片样式
export const CARD_STYLES = "bg-black/80 border border-green-900/50 shadow-xl hover:shadow-green-900/20 transition-all duration-300"

// Tabs 样式
// export const EXPLORE_TABS_CONTAINER = "w-full max-w-[360px] sm:max-w-[240px]"
export const EXPLORE_TABS_CONTAINER = "w-full max-w-[360px] sm:max-w-[240px]"
export const TABS_LIST_STYLES = "grid w-full grid-cols-2 gap-1 p-1 bg-black/60 border border-green-500/30 rounded-lg h-11 backdrop-blur-md shadow-[0_2px_8px_rgba(0,0,0,0.2)]"
export const TABS_TRIGGER_STYLES = "text-sm font-medium py-2.5 rounded-md data-[state=active]:bg-gradient-to-r from-green-400 to-cyan-400 data-[state=active]:text-white data-[state=active]:shadow-[0_0_10px_rgba(37,99,235,0.3)] transition-all duration-300 hover:text-green-400" 

// 标题和描述样式
export const GRADIENT_TITLE = "text-2xl md:text-3xl font-bold bg-gradient-to-r from-green-400 to-cyan-400 text-transparent bg-clip-text mb-1"
export const SUBTITLE_TEXT = "text-gray-400 text-sm max-w-md" 

// CTA 区块样式配置
export const CTA_STYLES = {
  CONTAINER: "py-20 bg-gradient-to-b from-black/90 to-black relative overflow-hidden",
  BACKGROUND: {
    WRAPPER: "absolute inset-0 overflow-hidden",
    GRADIENT: "absolute w-80 h-80 rounded-full blur-3xl opacity-30"
  },
  CONTENT: {
    WRAPPER: "max-w-4xl mx-auto text-center",
    CARD: "bg-black/60 backdrop-blur-md border border-green-500/20 rounded-xl p-8 shadow-[0_0_20px_rgba(37,99,235,0.15)]"
  },
  TITLE: "text-3xl md:text-5xl font-bold mb-6 leading-tight bg-gradient-to-r from-green-400 to-cyan-400 text-transparent bg-clip-text drop-shadow-[0_0_10px_rgba(37,99,235,0.3)]",
  DESCRIPTION: "text-xl text-gray-300 mb-10 max-w-2xl mx-auto",
  BUTTON: {
    PRIMARY: "bg-gradient-to-r from-green-400 to-cyan-400 hover:from-green-500 hover:to-cyan-500 text-white text-lg py-6 px-8 rounded-xl shadow-[0_0_15px_rgba(37,99,235,0.3)] hover:shadow-[0_0_20px_rgba(37,99,235,0.5)] transition-all hover:-translate-y-0.5",
    SECONDARY: "bg-transparent border border-green-500/20 text-gray-300 hover:text-white hover:border-green-500/40 transition-all"
  }
}

// Hero 区块样式配置
export const HERO_STYLES = {
  CONTAINER: "relative h-screen w-full overflow-hidden bg-black",
  VIDEO: {
    WRAPPER: "absolute inset-0 w-full h-full",
    OVERLAY: "absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80"
  },
  CONTENT: {
    WRAPPER: "relative z-10 h-full flex flex-col items-center justify-between pt-32 pb-16 px-4",
    TEXT_CONTAINER: "text-center",
    TITLE: "text-4xl md:text-6xl lg:text-7xl font-bold mb-6 text-white drop-shadow-[0_0_10px_rgba(37,99,235,0.5)]",
    GRADIENT_TEXT: "block mt-2 bg-gradient-to-r from-green-400 to-cyan-400 text-transparent bg-clip-text",
    DESCRIPTION: "text-xl text-gray-300 max-w-2xl mx-auto"
  },
  INPUT: {
    WRAPPER: "w-full max-w-4xl mx-auto px-4",
    FORM: {
      CONTAINER: "flex items-center gap-3 p-3 bg-black/60 backdrop-blur-md rounded-2xl border border-green-400/20 shadow-[0_0_15px_rgba(37,99,235,0.3)]",
      ICON_WRAPPER: "flex-shrink-0",
      ICON_BUTTON: "w-10 h-10 rounded-full bg-gradient-to-r from-green-400 to-cyan-400 flex items-center justify-center group transition-all duration-300",
      ICON: "w-5 h-5 text-white group-hover:scale-110 transition-transform",
      INPUT: "flex-grow bg-transparent border-0 text-white placeholder-gray-400 text-lg focus-visible:ring-0 focus-visible:ring-offset-0",
      SUBMIT_BUTTON: "flex-shrink-0 bg-gradient-to-r from-green-400 to-cyan-400 hover:from-green-500 hover:to-cyan-500 text-white px-8 py-6 text-lg rounded-xl shadow-[0_0_15px_rgba(37,99,235,0.3)] hover:shadow-[0_0_20px_rgba(37,99,235,0.5)] transition-all hover:-translate-y-0.5"
    },
    EXAMPLES: {
      WRAPPER: "mt-4 flex flex-wrap justify-center gap-2",
      BUTTON: "px-4 py-2 rounded-full bg-black/50 backdrop-blur-md border border-green-400/20 hover:bg-green-400/10 text-sm text-gray-300 transition-colors hover:text-green-400 hover:border-green-400/40"
    }
  }
} 